import React from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as ChevronLeftIcon } from '../images/icons/chevron-left.svg';
import { ReactComponent as ChevronRightIcon } from '../images/icons/chevron-right.svg';
import { colourNeutral09, colourNeutral10 } from '../styling/colours';
import { spacing05 } from '../styling/spacing';
import { SecondaryButton } from './Button';

export type Props = {
  currentPageNumber: number;
  onChangeCurrentPageNumber: (page: number) => void;
  totalNumberOfPages: number;
};

export const PaginationControl = ({ currentPageNumber, onChangeCurrentPageNumber, totalNumberOfPages }: Props) => {
  const goBack = () => onChangeCurrentPageNumber(currentPageNumber - 1);
  const goForward = () => onChangeCurrentPageNumber(currentPageNumber + 1);

  return (
    <Container>
      <PaginationButton onClick={goBack} disabled={currentPageNumber === 1} data-testid={pageBackwardsButtonTestId}>
        <ChevronLeftIcon />
      </PaginationButton>
      <PageNumberLabel>{`Page ${currentPageNumber} of ${totalNumberOfPages}`}</PageNumberLabel>
      <PaginationButton
        onClick={goForward}
        disabled={currentPageNumber === totalNumberOfPages}
        data-testid={pageForwardsButtonTestId}
      >
        <ChevronRightIcon />
      </PaginationButton>
    </Container>
  );
};

export const pageBackwardsButtonTestId = 'page-backwards-button';
export const pageForwardsButtonTestId = 'page-forwards-button';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const paginationButtonIconSize = spacing05;

const PaginationButton = styled(SecondaryButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  svg {
    height: ${paginationButtonIconSize};
    width: ${paginationButtonIconSize};
  }
`;

const PageNumberLabel = styled.div`
  background-color: ${colourNeutral10};
  border: solid 1px ${colourNeutral09};
  padding: 0 ${spacing05};
  display: flex;
  align-items: center;
  height: 38px;
`;
